import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = { class: "input-box-wrapper" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "options-box-anchor"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src", "onClick"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "options-box-anchor"
}
const _hoisted_10 = ["src"]

import {
  computed,
  ref,
  onMounted,
  watch,
  shallowRef,
  PropType,
  toRefs,
  nextTick,
  onBeforeMount,
} from "vue";
import router from "@/router";
import { getIcon } from "@/helpers/api";
import CssUtils from "@/helpers/cssUtils";
import { IFont, getFont } from "@/helpers/fonts";
import { nanoid } from "nanoid";
import { useOpenInputMediaStore } from "@/modules/a.worksheets/stores/openInputMediaStore";
import { useDeviceStatus } from "@/stores/deviceStatus";
import WksOpenInputPopUpBtn from "@/modules/a.worksheets/views/components/footer/WksOpenInputPopUpBtn.vue";
import WksOpenInputBtn from "@/modules/a.worksheets/views/components/footer/WksOpenInputBtn.vue";
import { TInputButton } from "@/modules/a.worksheets/helpers/wksOpenInput";
import { RouteParamsRaw } from "vue-router";
import { computedAsync } from "@vueuse/core";
import ModalText from "@/globals/modules/ModalText.vue";
import { Quill, QuillEditor } from "@vueup/vue-quill";
import Delta from "quill-delta";
import { useUserAnswersData } from "@/modules/a.worksheets/stores/wksUserAnswersDataStore";
import TextEditorResponse from "@/globals/modules/TextEditorResponse.vue";
import { IActivity } from "@/modules/a.worksheets/stores/worksheetDataStore";
import MilageTextEditor from "@/globals/modules/MilageTextEditor/MilageTextEditor.vue";
import { IonIcon } from "@ionic/vue";
import { textOutline } from "ionicons/icons";
import { useOpenAnswerDraftStore } from "@/modules/a.worksheets/stores/openAnswerDraftStore";
import { problemEvidenceMandatory } from "@/modules/a.worksheets/helpers/evidence";


export default /*@__PURE__*/_defineComponent({
  __name: 'WksOpenInput',
  props: {
  mediaButton: {
    type: Array<TInputButton>,
    default: undefined,
  },
  placeholder: { type: String, default: "" },
  textBtn: {
    type: Object as PropType<{ src: string; route: string }>,
    default: undefined,
  },
  isText: { type: Boolean, default: true },
  params: { type: Object as PropType<RouteParamsRaw>, default: () => ({}) },
  currentActivity: {
    type: Object as PropType<IActivity>,
    default: () => null,
  },
  preview: { type: Boolean, default: false },
  editorInBody: { type: Boolean, default: false },
},
  emits: ["set-final-router", "set-media"],
  setup(__props, { emit: __emit }) {

const { isWeb } = toRefs(useDeviceStatus());
const answerStore = useUserAnswersData();

const isOptionsBoxOpen = ref(false);
const props = __props;
const emit = __emit;

const inputRef = shallowRef<HTMLTextAreaElement | null>(null);

const nore12 = ref<IFont>();
const nore16 = ref<IFont>();

const plusSvg = ref<string | undefined>();
const sendSvg = ref<string | undefined>();
onMounted(async () => {
  console.log("ISTEXT", props.isText);
  plusSvg.value = await getIcon("1602", "plus");
  nore12.value = await getFont("nore12");
  nore16.value = await getFont("nore16");
  const sendBlobUrl = await getIcon("1610A", "send");
  if (sendBlobUrl) {
    sendSvg.value = await fetch(sendBlobUrl).then((r) => r.text());
  }
});

const draftStore = useOpenAnswerDraftStore();

function sendOpenAnswerDraft() {
  if (props.preview || !draftStore.content) return;

  emit("set-media", draftStore.content, "text");
  draftStore.clear();
}

const getInputIconButtons = computed(() => {
  if (props.mediaButton) {
    if (props.mediaButton.length < 3) {
      return props.mediaButton;
    } else if (props.mediaButton.length > 3) {
      return [props.mediaButton[0], props.mediaButton[1]];
    } else {
      return [props.mediaButton[0], props.mediaButton[1], props.mediaButton[2]];
    }
  }
  return [];
});

const modifiedButtons = computedAsync<
  Array<{
    route: string;
    src: string;
    svg: string;
    name: string;
    routeName: string;
  }>
>(async () => {
  if (props.mediaButton && props.mediaButton.length > 3) {
    const buttons = props.mediaButton.slice(2);
    const modButtons = buttons.map(async (btn) => {
      console.log("btn: ", btn);
      return {
        route: btn.route,
        src: btn.src,
        name: btn.name,
        svg: await fetch(btn.src).then((res) => res.text()),
        routeName: btn.routeName,
      };
    });
    const resolvedBtn = await Promise.all(modButtons);
    resolvedBtn.forEach((btn) => {
      btn.svg = new CssUtils(btn.svg)
        .setSvgFill("var(--milage-color-primary)")
        .removeSvgAttribute("width")
        .removeSvgAttribute("height")
        .addStyle("width: 60%; height: 60%;")
        .build();
    });
    console.log("resolvedBtn: ", resolvedBtn);
    return resolvedBtn;
  } else {
    return [];
  }
});

const toggleOptionsBox = async () => {
  isOptionsBoxOpen.value = !isOptionsBoxOpen.value;
};

const getInputCSS = computed(() => {
  const backgroundColor = isWeb.value
    ? "var(--worksheet-difficulty-bg)"
    : "#EFEFEF";

  document.documentElement.style.setProperty(
    "--tootlip-toolbar-bck",
    backgroundColor,
  );

  return {
    "--placeholder-font": isWeb.value
      ? nore16.value?.["font-family"]
      : nore12.value?.["font-family"],
    "--placeholder-font-size": isWeb.value
      ? nore16.value?.["font-size"]
      : nore12.value?.["font-size"],
    "--placeholder-font-weight": isWeb.value
      ? nore16.value?.["font-weight"]
      : nore12.value?.["font-weight"],
    "--placeholder-transform": isWeb.value
      ? nore16.value?.["text-transform"]
      : nore12.value?.["text-transform"],
    "--input-background": backgroundColor,
  };
});

const setInputText = (e: InputEvent) =>
  (text.value = e.target ? (e.target as HTMLTextAreaElement).value : "");

const text = ref("");

const isWordSelection = computed(
  () =>
    props.currentActivity?.problem?.problem_type === "words-selection" ||
    props.currentActivity.problem?.problem_type ===
      "multiple-choices-graphical" ||
    props.currentActivity?.problem?.problem_type === "sequence-ordering" ||
    props.currentActivity?.problem?.problem_type === "words-drag-drop" ||
    props.currentActivity?.problem?.problem_type === "match-options" ||
    props.currentActivity?.problem?.problem_type === "image-labelling" ||
    props.currentActivity?.problem?.problem_type === "table-fill",
);

// Interativas com evidência: a seta aparece mas fica indisponível até a justificação estar escrita
// (só quando é obrigatória - is_evidence_mandatory)
const evidenceMissing = computed(
  () =>
    problemEvidenceMandatory(props.currentActivity?.problem) &&
    !answerStore.hasEvidence,
);

console.log("currentActivity", props.currentActivity);

function sendWordSelection() {
  if (props.preview || evidenceMissing.value) return;

  console.log("clicou");
  let answerType = "word_selection";
  const problemType = props.currentActivity.problem?.problem_type;
  if (problemType === "words-drag-drop") {
    answerType = "words-drag-drop";
  }
  if (problemType === "match-options") {
    answerType = "match-options";
  }

  if (problemType === "image-labelling") {
    answerType = "image-labelling";
  }

  if (problemType === "table-fill") {
    answerType = "table-fill";
  }

  if (problemType === "sequence-ordering") {
    answerType = "sequence-ordering";
  }

  if (problemType === "multiple-choices-graphical") {
    answerType = "multiple-choices-graphical";
  }

  emit("set-media", {}, answerType);
}

async function sendText() {
  if (props.preview) return;

  emit("set-media", contentFromModal.value, "text");
  if (inputRef.value) inputRef.value.value = "";
}

// CROSS PAGE COMMUNICATION
const id = nanoid();

const openInputMediaStore = useOpenInputMediaStore();
watch(openInputMediaStore.openInput, (mapping) => {
  const data = mapping.get(id);
  if (data) {
    emit("set-media", data.data, data.type);
    console.log("WksOpenInput Caught data from the Store!", data);
  }
});

const textAreaRows = ref<number>(1);
function growArea() {
  textAreaRows.value = 5;
}
function shrinkArea(e: FocusEvent) {
  setTimeout(() => {
    textAreaRows.value = 1;
  }, 100);
}
// ------

function openRoute(name: string, params: RouteParamsRaw) {
  console.warn("route name: ", name);
  console.warn("params: ", params);
  router.push({
    name,
    params,
  });
}

function handleOpenRoute(routeName: string) {
  console.log("Abrindo rota:", routeName);
  openRoute(routeName, props.params);
}

//Quill

const editSvg = ref<string>();

onBeforeMount(async () => {
  editSvg.value = await getIcon("1501", "edit");
});

const viewerEditorOptions = {
  theme: "snow",
  modules: {
    toolbar: false,
  },
};

const contentFromModal = ref<Delta | null>(null);

const viewerQuillEditorRef = ref<
  (InstanceType<typeof QuillEditor> & { quill?: Quill }) | null
>(null);
const selectedTaskIndex = ref<number>();

watch(contentFromModal, async (newDelta) => {
  if (viewerQuillEditorRef.value && newDelta) {
    await nextTick();
    const quill = viewerQuillEditorRef.value.getQuill();

    const compatibleDelta = JSON.parse(JSON.stringify(newDelta));
    quill.setContents(compatibleDelta);
  }
});

function isDeltaEmptyOrOnlyNewlines(delta: Delta): boolean {
  return delta.ops.every((op) => {
    if (typeof op.insert === "string") {
      return op.insert.trim() === "";
    }
    return false;
  });
}

const onUpdateContent = (content: Delta) => {
  if (isDeltaEmptyOrOnlyNewlines(content)) {
    contentFromModal.value = null;
  } else {
    const changed =
      JSON.stringify(contentFromModal.value) !== JSON.stringify(content);
    console.log(
      "contentFromModal.value",
      contentFromModal.value,
      "content",
      content,
      "AQUI",
      changed,
    );
    contentFromModal.value = content;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flexbox relative", { 'is-preview-frozen': __props.preview, 'flexbox-compact': __props.editorInBody }]),
    style: _normalizeStyle(getInputCSS.value)
  }, [
    (!__props.editorInBody)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (__props.isText)
              ? (_openBlock(), _createBlock(MilageTextEditor, {
                  class: "editor-response",
                  key: selectedTaskIndex.value,
                  "initial-content": contentFromModal.value,
                  "is-creation": false,
                  "onUpdate:modelValue": onUpdateContent,
                  operators: _unref(answerStore).keyboard_latex?.keyboard,
                  "math-live-options": _unref(answerStore).keyboard_latex.mathLiveOptions,
                  "toolbar-content": _unref(answerStore).keyboard_latex.editorOptions
                }, null, 8, ["initial-content", "operators", "math-live-options", "toolbar-content"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "send" }, {
      default: _withCtx(() => [
        (isWordSelection.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["send-button", { 'is-disabled': evidenceMissing.value }]),
              onClick: sendWordSelection,
              innerHTML: sendSvg.value
            }, null, 10, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!_unref(isWeb))
      ? (_openBlock(), _createBlock(_Transition, {
          key: 1,
          name: "icons"
        }, {
          default: _withCtx(() => [
            (
          (contentFromModal.value && contentFromModal.value.ops.length === 0) ||
          !contentFromModal.value
        )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["icons", { 'icons-inline': __props.editorInBody }])
                }, [
                  (isOptionsBoxOpen.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(WksOpenInputPopUpBtn, {
                          buttons: _unref(modifiedButtons),
                          onClick: _cache[0] || (_cache[0] = (name) => openRoute(name, __props.params))
                        }, null, 8, ["buttons"])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.mediaButton && __props.mediaButton.length > 3)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: plusSvg.value,
                        onClick: toggleOptionsBox
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getInputIconButtons.value, (button, key) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: key,
                      src: button.src,
                      onClick: ($event: any) => (openRoute(button.routeName, __props.params))
                    }, null, 8, _hoisted_6))
                  }), 128))
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "send" }, {
      default: _withCtx(() => [
        (
          !__props.editorInBody && contentFromModal.value && contentFromModal.value.ops.length > 0
        )
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "send-button",
              onClick: sendText,
              innerHTML: sendSvg.value
            }, null, 8, _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "send" }, {
      default: _withCtx(() => [
        (__props.editorInBody && _unref(draftStore).hasContent)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "send-button send-button-inline",
              onClick: sendOpenAnswerDraft,
              innerHTML: sendSvg.value
            }, null, 8, _hoisted_8))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (
        _unref(isWeb) &&
        ((contentFromModal.value && contentFromModal.value.ops.length === 0) ||
          !contentFromModal.value)
      )
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["icons", { 'icons-inline': __props.editorInBody }])
        }, [
          (isOptionsBoxOpen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(WksOpenInputPopUpBtn, {
                  buttons: _unref(modifiedButtons),
                  onClick: _cache[1] || (_cache[1] = (r) => openRoute(r, __props.params))
                }, null, 8, ["buttons"])
              ]))
            : _createCommentVNode("", true),
          (__props.mediaButton && __props.mediaButton.length > 3)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: plusSvg.value,
                onClick: toggleOptionsBox
              }, null, 8, _hoisted_10))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getInputIconButtons.value, (button, key) => {
            return (_openBlock(), _createBlock(WksOpenInputBtn, {
              key: key,
              src: button.src,
              "route-name": button.routeName,
              onClick: handleOpenRoute
            }, null, 8, ["src", "route-name"]))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ], 6))
}
}

})